<template>
<div class="chapter">
<div class="inner_page">
<a id="page_2"></a>
<div class="blue">
<p class="copyt">First published in 2020</p>
<p class="copy">Search Press Limited</p>
<p class="copy">Wellwood, North Farm Road,</p>
<p class="copy">Tunbridge Wells, Kent TN2 3DR</p>
<p class="copy">United Kingdom</p>
<p class="copy1">Photograph of the Janome longarm sewing machine on page 13 is used with kind permission from, and remains the copyright of, Janome UK Ltd. For more information on Janome machines, please visit the website: <span class="weblink"><a href="http://www.janome.co.uk" target="_blank"><span class="underline">www.janome.co.uk</span></a></span></p>
<p class="copy1">All remaining photographs by Garie Hind.</p>
<p class="copy1">Text copyright © Debbie Shore, 2020</p>
<p class="copy">Photographs © Garie Hind, 2020</p>
<p class="copy">Design copyright © Search Press Ltd., 2020</p>
<p class="copy1">All rights reserved. No part of this book, text, photographs or illustrations may be reproduced or transmitted in any form or by any means by print, photoprint, microfilm, microfiche, photocopier, internet or in any way known or as yet unknown, or stored in a retrieval system, without written permission obtained beforehand from Search Press.</p>
<p class="copy1">ISBN: 978-1-78221-547-9</p>
<p class="copy">EISBN: 978-1-78126-943-5</p>
<p class="copy1">The Publishers and author can accept no responsibility for any consequences arising from the information, advice or instructions given in this publication.</p>
<p class="copy1">Readers are permitted to reproduce any of the items/patterns in this book for their personal use, or for the purposes of selling for charity, free of charge and without the prior permission of the Publishers. Any use of the items/patterns for commercial purposes is not permitted without the prior permission of the Publishers.</p>
<p class="copy1">Suppliers</p>
<p class="copy">For details of suppliers, please visit the Search Press website: <span class="weblink"><a href="http://www.searchpress.com" target="_blank"><span class="underline">www.searchpress.com</span></a></span></p>
<p class="copy1">For further inspiration:</p>
<p class="copy1">– join the Half Yard Sewing Club:</p>
<p class="copy"><span class="weblink"><a href="http://www.halfyardsewingclub.com" target="_blank"><span class="underline">www.halfyardsewingclub.com</span></a></span></p>
<div class="img_container">
<img alt="Image" src="images/copy.jpg"/>
</div>
<p class="copy">– visit Debbie’s YouTube channel:</p>
<p class="copy"><span class="weblink"><a href="http://www.youtube.com/user/thimblelane" target="_blank"><span class="underline">www.youtube.com/user/thimblelane</span></a></span></p>
<p class="copy1">– visit Debbie’s website:</p>
<p class="copy"><span class="weblink"><a href="http://www.debbieshoresewing.com" target="_blank"><span class="underline">www.debbieshoresewing.com</span></a></span></p>
<p class="copy1a">Templates for the eBook edition of this book can be found at: <span class="weblink"><a href="http://www.searchpress.com/sewing-room-secrets-quilting-ebook" target="_blank"><span class="underline">www.searchpress.com/sewing-room-secrets-quilting-ebook</span></a></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?64f28e22